var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[(_vm.item)?_c('StrapiMarkdownComponent',{attrs:{"item":_vm.item.attributes.contenu}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }